// Compressão de vídeo no navegador (WebCodecs via mediabunny) antes do upload:
// reduz para H.264 720p com o índice (moov) no início do arquivo — o upload fica bem
// mais rápido e o vídeo começa a tocar logo no catálogo. Qualquer falha ou falta de
// suporte devolve null e quem chamou envia o arquivo original, como sempre foi.

const ALTURA_MAX = 720;
const VIDEO_BITRATE = 3_000_000;
const AUDIO_BITRATE = 96_000;

// Abaixo disso não compensa o tempo de conversão.
export const TAMANHO_MINIMO_COMPRIMIR = 20 * 1024 * 1024;

export async function comprimirVideo(file, onProgress) {
  try {
    if (typeof VideoEncoder === 'undefined' || typeof VideoDecoder === 'undefined') return null;

    const { Input, Output, Conversion, BlobSource, BufferTarget, Mp4OutputFormat, ALL_FORMATS, canEncodeVideo } =
      await import('mediabunny');

    if (!(await canEncodeVideo('avc', { width: 1280, height: 720, bitrate: VIDEO_BITRATE }))) return null;

    const input = new Input({ source: new BlobSource(file), formats: ALL_FORMATS });
    const trilhaVideo = await input.getPrimaryVideoTrack();
    if (!trilhaVideo) return null;

    const output = new Output({
      format: new Mp4OutputFormat({ fastStart: 'in-memory' }),
      target: new BufferTarget(),
    });

    const conversion = await Conversion.init({
      input,
      output,
      video: {
        codec: 'avc',
        bitrate: VIDEO_BITRATE,
        // Só reduz — nunca amplia um vídeo menor que 720p.
        ...(trilhaVideo.displayHeight > ALTURA_MAX ? { height: ALTURA_MAX } : {}),
      },
      audio: { codec: 'aac', bitrate: AUDIO_BITRATE },
    });
    if (!conversion.isValid) return null;

    if (onProgress) conversion.onProgress = (p) => onProgress(Math.round(p * 100));
    await conversion.execute();

    const buffer = output.target.buffer;
    if (!buffer || buffer.byteLength === 0 || buffer.byteLength >= file.size) return null;

    return new Blob([buffer], { type: 'video/mp4' });
  } catch (err) {
    console.warn('Compressão de vídeo indisponível, enviando original:', err);
    return null;
  }
}
